var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurso25NubePos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 892.8 451.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #4d4d4d;\n        stroke-linecap: round;\n        stroke-width: 4px;\n      }\n\n      .st0, .st1, .st2 {\n        stroke-miterlimit: 10;\n      }\n\n      .st1, .st3 {\n        fill: #ed7851;\n      }\n\n      .st1, .st2 {\n        stroke: #ed7850;\n        stroke-width: 2px;\n      }\n\n      .st4 {\n        fill: #4d4d4d;\n      }\n\n      .st5 {\n        isolation: isolate;\n      }\n\n      .st2, .st6 {\n        fill: #ed7850;\n      }\n\n      .st7 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M783.5,197.4v2.6h-11v-14.3h10.8v2.6h-7.5v3.1h6.6v2.6h-6.6v3.3h7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M795.2,200l-2.7-4h-3v4h-3.3v-14.3h6.2c1.3,0,2.4.2,3.3.6.9.4,1.6,1,2.1,1.8s.8,1.7.8,2.7-.3,2-.8,2.7-1.2,1.4-2.2,1.8l3.2,4.6h-3.5ZM794.4,189.1c-.5-.4-1.3-.6-2.3-.6h-2.7v5h2.7c1,0,1.7-.2,2.3-.7s.8-1,.8-1.8-.3-1.4-.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M810.6,186.4c.9.4,1.6,1,2.1,1.8s.8,1.7.8,2.7-.3,2-.8,2.7-1.2,1.4-2.1,1.8c-.9.4-2,.6-3.3.6h-2.9v3.9h-3.3v-14.3h6.2c1.3,0,2.4.2,3.3.6ZM809.4,192.7c.5-.4.8-1,.8-1.8s-.3-1.4-.8-1.8-1.3-.6-2.3-.6h-2.7v4.9h2.7c1,0,1.7-.2,2.3-.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M577.1,112.7c5.4,1.1,10.9,1.5,16.3,2.8,72.4,17.8,88,115.5,25.5,155.8-26.6,17.2-50.8,13.4-80.8,13.6-62,.5-124.3.8-186.4.9-32.6,0-57,4-85.9-15.1-62.1-41.2-51.4-135.5,16.7-163.3,6.5-31.6,35-51.5,67.2-45.3,6.3,1.2,11.4,4,17.2,6.4C384.3,24.3,429.2-3.3,476.7.3c57.5,4.4,102.7,54.6,100.4,112.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M514.6,257.6c.8,0,1.6,0,2.4-.1,6.8-1.7,13.2-4.3,18.7-8.7,6.1-4.9,9.4-11.2,9.3-19,0-6.6,0-13.2,0-19.8,0-1.6-.3-3.1-1-4.6-1-2.2-2.2-4.4-3.6-6.4-5.8-8-13.5-12.6-23.9-12.6-43.4,0-86.8,0-130.2,0h-1.7c-1.7,0-1.7,0-1.7-1.6,0-3,0-5.9,0-8.9,0-1.7,0-1.7,1.8-1.7,6,0,12,0,18-.1,16.5-.1,33,0,49.5-.1,27.4,0,155.3,0,202.1,0-3.4-11.6-9.2-22.5-17.1-31.8h-247.4c-3.4,0-6.6.3-9.9,1.2-1.3.4-2.6.8-3.9,1.2-5.4,1.7-10.5,4.1-15,7.5-5.7,4.4-8.9,9.9-8.7,17.1.1,7.1.1,14.1,0,21.2,0,2.4.4,4.6,1.6,6.6.5.8.9,1.6,1.4,2.3,3.2,5,7.5,8.9,13,11.6,4.8,2.3,9.9,3.2,15.2,3.2h127.4c2.2,0,2.2,0,2.2,2s0,5.4,0,8c0,3.2.4,3-3,3H230.8c4.2,11,10.6,21.4,19.3,30.4h264.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M869.2,144.3h-103.8c-13,0-23.5,10.5-23.5,23.5v45.1c0,13,10.5,23.5,23.5,23.5h49.4v25.4h-35.2v5h75.4v-5h-35.2v-25.4h49.4c13,0,23.5-10.5,23.5-23.5v-45.1c0-13-10.5-23.5-23.5-23.5h0ZM887.8,213c0,10.2-8.3,18.5-18.5,18.5h-103.8c-10.2,0-18.5-8.3-18.5-18.5v-45.2c0-10.2,8.3-18.5,18.5-18.5h103.8c10.2,0,18.5,8.3,18.5,18.5v45.1h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 193.3,
    y1: 232.2,
    x2: 158.6,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "172.7 246.4 158.6 232.2 172.9 217.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 173.2,
    y1: 232.2,
    x2: 207.9,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "193.8 218 208 232.2 193.7 246.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 448.4,
    y1: 317,
    x2: 448.4,
    y2: 351.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "462.6 337.6 448.4 351.8 434.1 337.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 448.4,
    y1: 337.1,
    x2: 448.4,
    y2: 302.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "434.2 316.5 448.4 302.3 462.7 316.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 708.7,
    y1: 232.2,
    x2: 674,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "688.1 246.4 673.9 232.2 688.3 217.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 688.6,
    y1: 232.2,
    x2: 723.3,
    y2: 232.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "709.2 218 723.4 232.2 709.1 246.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.9,236.1h-6.6l-1.3,3.1h-3.4l6.4-14.3h3.3l6.4,14.3h-3.5l-1.3-3.1ZM51.9,233.6l-2.3-5.5-2.3,5.5h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M59.1,224.9h6.5c1.5,0,2.9.3,4.1.9,1.2.6,2.1,1.4,2.8,2.5s1,2.3,1,3.7-.3,2.7-1,3.7-1.6,1.9-2.8,2.5c-1.2.6-2.6.9-4.1.9h-6.5v-14.3ZM65.4,236.4c1.4,0,2.6-.4,3.4-1.2.8-.8,1.3-1.9,1.3-3.2s-.4-2.4-1.3-3.2c-.8-.8-2-1.2-3.4-1.2h-3v8.8h3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.5,237.7c-1.1-1.1-1.7-2.7-1.7-4.8v-8h3.3v7.9c0,2.6,1.1,3.8,3.2,3.8s1.8-.3,2.4-.9c.5-.6.8-1.6.8-2.9v-7.9h3.3v8c0,2.1-.6,3.7-1.7,4.8-1.1,1.1-2.7,1.7-4.8,1.7s-3.6-.6-4.8-1.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.1,236.1h-6.6l-1.3,3.1h-3.4l6.4-14.3h3.3l6.4,14.3h-3.5l-1.3-3.1ZM100,233.6l-2.3-5.5-2.3,5.5h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M120.3,224.9v14.3h-2.7l-7.1-8.7v8.7h-3.3v-14.3h2.7l7.1,8.7v-8.7h3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.1,236.1h-6.6l-1.3,3.1h-3.4l6.4-14.3h3.3l6.4,14.3h-3.5l-1.3-3.1ZM132.1,233.6l-2.3-5.5-2.3,5.5h4.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M545.2,405.7h-18.3c-.7,0-1.2-.5-1.2-1.2s.5-1.2,1.2-1.2h18.3c.7,0,1.2.5,1.2,1.2s-.5,1.2-1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M564.6,405.7h-6c-.7,0-1.2-.5-1.2-1.2s.5-1.2,1.2-1.2h6c1.3,0,2.4-1.1,2.4-2.4v-11.4c0-.6-.2-1.1-.6-1.6l-6.1-7.6-4.9-6c-.3-.4-.7-.6-1.2-.6h-11.6c-.7-.1-1.2-.6-1.2-1.3v-9.1c0-1.3-1.2-2.4-2.5-2.4h-31.5c-1.4,0-2.4,1.1-2.4,2.4v37.7c0,1.4,1.1,2.4,2.4,2.4h5.8c.7,0,1.2.5,1.2,1.2s-.5,1.2-1.2,1.2h-5.8c-2.7,0-4.9-2.2-4.9-4.9v-37.7c0-2.7,2.2-4.9,4.9-4.9h31.5c2.7,0,4.9,2.2,4.9,4.9v7.9c0,0,10.4,0,10.4,0,1.2,0,2.3.5,3.1,1.5l4.9,6,6.1,7.7c.7.9,1.1,2,1.1,3.1v11.4c0,2.7-2.2,4.9-4.9,4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M542.7,405.7c-.7,0-1.2-.5-1.2-1.2v-32.3c0-.7.5-1.2,1.2-1.2s1.2.5,1.2,1.2v32.3c0,.7-.5,1.2-1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M520.1,412.1c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8,7.8,3.5,7.8,7.8-3.5,7.8-7.8,7.8ZM520.1,399.1c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3,5.3-2.4,5.3-5.3-2.4-5.3-5.3-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M552,412.1c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8,7.8,3.5,7.8,7.8-3.5,7.8-7.8,7.8ZM552,399.1c-2.9,0-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3,5.3-2.4,5.3-5.3-2.4-5.3-5.3-5.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.2,384c.7,0,1.2-.5,1.2-1.2v-15.6c0-3.2,1.7-5.9,3.7-5.9h34.2c2,0,3.7,2.7,3.7,5.9v15.6c0,.7.5,1.2,1.2,1.2s1.2-.5,1.2-1.2v-15.6c0-4.7-2.7-8.4-6.2-8.4h-15.9v-8.7c0-.7-.5-1.2-1.2-1.2s-1.2.5-1.2,1.2v8.6h0s-15.9,0-15.9,0c-3.5,0-6.2,3.7-6.2,8.4v15.6c0,.7.5,1.2,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.5,389.1c0-.5-.2-1-.7-1.3l-29.5-13.4-29.5,13.4s0,0,0,0c0,0-.1.1-.2.1,0,0-.1,0-.2.1,0,0,0,.1-.1.2s0,.1-.1.2c0,0,0,.1,0,.2,0,0,0,.2,0,.3h0c2,16.9,8.4,23.1,8.7,23.4.2.2.5.3.8.3s.7-.1.9-.4c.5-.5.4-1.3,0-1.8,0,0-5.9-5.7-7.8-20.9l26.5-12c0,.1,0,.2,0,.4v10.1c0,.7.5,1.2,1.2,1.2s1.2-.5,1.2-1.2v-10.1c0-.1,0-.2,0-.4l26.5,12c-1,8.1-3.1,13.7-4.7,17-.3.6,0,1.4.6,1.6.2,0,.4.1.5.1.5,0,.9-.3,1.1-.7,1.7-3.6,4-9.7,5-18.5,0,0,0-.1,0-.2h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.9,415.6c-3.5,0-6.8-2.1-9-3.6-2.8-1.9-5.6-3.5-8.4-3.1-2,.2-3.8,1.5-5.6,2.8-1.3.9-2.6,1.8-4,2.5-4.8,2.2-10.9.9-14.4-3-.5-.5-.4-1.3,0-1.8.5-.5,1.3-.4,1.8,0,2.8,3.1,7.8,4.1,11.6,2.4,1.2-.6,2.4-1.4,3.6-2.2,2-1.4,4.1-2.9,6.7-3.2,3.6-.5,6.8,1.4,10.1,3.5,2.8,1.9,5.6,3.5,8.4,3.1,2.1-.3,3.9-1.6,5.8-3,1.4-1,2.8-2.1,4.4-2.8,4.5-2,13.4-.1,17.3,4.9.4.5.3,1.3-.2,1.7-.5.4-1.3.3-1.7-.2-3.1-4-10.7-5.8-14.3-4.2-1.4.6-2.6,1.5-3.9,2.5-2.1,1.5-4.2,3.1-6.9,3.5-.4,0-.7,0-1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489.5,380.1c-1.1-1.1-2.5-1.6-4-1.4l-2.2.3c-6.8.9-13.1,4.3-17.7,9.4l-1.9,2.1-9.6-2.4h0l-11.3-2.8h0l-11.1-2.7c-.4-.1-.8,0-1.1.3l-5.2,5c-.3.3-.4.6-.4,1,0,.3.1.5.3.7,0,0,.1.1.2.2l24.4,16.1-11.2,12.4-15.4-1.2c-.4,0-.7.1-.9.3l-4.6,4.4c-.3.3-.4.7-.4,1.1,0,.2.1.5.3.7s.2.2.3.2l13.8,6.7v.3c-.5,1.4-.2,2.9.9,4h0c1,1.1,2.5,1.5,3.9,1.1h.3c0,0,6.2,13.9,6.2,13.9,0,.1.1.2.2.4.2.2.4.3.6.4.4,0,.8,0,1.1-.3l4.6-4.4c.2-.2.4-.6.4-.9l-.6-15.5,12.8-10.7,15.2,25c0,0,.1.1.2.2.2.2.4.3.7.4.4,0,.7,0,1-.3l5.2-5c.3-.3.4-.7.4-1.1l-2.3-11.2h0l-2.4-11.5h0l-2-9.7,2.2-1.8c5.3-4.4,8.8-10.5,10-17.3l.4-2.2c.3-1.5-.2-3-1.2-4.1h0ZM428,388.6l3.6-3.5,30.1,7.4-10.4,11.6-23.4-15.5h0ZM482.2,437.7l-3.6,3.5-14.6-24,12-10,6.3,30.4h0ZM488.3,383.8l-.4,2.2c-1.1,6.2-4.4,11.8-9.2,15.9l-31.5,26.2c-.1.1-.3.2-.5.4l.6,16.1-2.9,2.8-6.2-14.4c-.4.1-.7.2-1.1.3l-1.3.3c-.6.1-1.1,0-1.5-.4h0c-.4-.4-.5-1-.4-1.6l.4-1.3c.1-.4.3-.8.5-1.2l-14.2-6.7,2.9-2.8,16,1.5c.2-.2.3-.4.5-.6l27.4-30.4c4.2-4.7,10-7.7,16.2-8.6l2.2-.3c.7-.1,1.4.1,1.9.7.5.5.7,1.2.6,2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M868.9,185.8c.2.7,0,1.4-.5,1.9l-3.3,3c0,.6.1,1.3.1,2s0,1.3-.1,2l3.3,3c.5.5.7,1.2.5,1.9-.3.9-.8,1.8-1.2,2.6l-.4.6c-.5.9-1.1,1.6-1.7,2.4-.5.6-1.2.7-1.9.5l-4.3-1.4c-1,.8-2.2,1.4-3.4,2l-1,4.4c-.2.7-.7,1.2-1.4,1.4-1.1.2-2.2.3-3.3.3s-2.2,0-3.3-.3c-.7-.1-1.2-.7-1.4-1.4l-1-4.4c-1.2-.5-2.4-1.2-3.4-2l-4.3,1.4c-.7.2-1.4,0-1.9-.5-.6-.8-1.2-1.6-1.7-2.4l-.4-.6c-.5-.9-.9-1.7-1.2-2.6-.2-.7,0-1.4.5-1.9l3.3-3c0-.6-.1-1.3-.1-2s0-1.3.1-2l-3.3-3c-.5-.5-.7-1.2-.5-1.9.3-.9.8-1.8,1.2-2.6l.4-.6c.5-.9,1.1-1.6,1.7-2.4.5-.6,1.2-.7,1.9-.5l4.3,1.4c1-.8,2.2-1.4,3.4-2l1-4.4c.2-.7.7-1.2,1.4-1.4,1.1-.2,2.2-.3,3.3-.3s2.2,0,3.3.3c.7.1,1.2.7,1.4,1.4l1,4.4c1.2.5,2.4,1.2,3.4,2l4.3-1.4c.7-.2,1.4,0,1.9.5.6.8,1.2,1.6,1.7,2.4l.4.6c.5.9.9,1.7,1.2,2.6h0ZM850.5,198.9c3.4,0,6.2-2.8,6.2-6.2s-2.8-6.2-6.2-6.2-6.2,2.8-6.2,6.2,2.8,6.2,6.2,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.2,162.2c0-.1,0-.2,0-.3-.2-.6-.6-1.1-1.1-1.4l-63-36.7c-3.2-1.9-7.3-1.9-10.5,0L5.2,158c-3.2,1.9-5.2,5.4-5.2,9.1v68.4c0,3.8,2,7.3,5.3,9.1l62.9,35.9c.2.1.4.2.6.2s.4,0,.6,0h0c.2,0,.4,0,.6,0,0,0,0,0,.2,0,.2,0,.3-.1.4-.2l39.2-22.1c1.2-.7,1.6-2.2.9-3.4-.7-1.2-2.2-1.6-3.4-.9l-35.4,20v-27.2h-5v27.2L7.8,240.4c-1.7-1-2.8-2.8-2.8-4.8v-68.4c0-.1,0-.3,0-.4l62,36.2v14.8h5v-14.8l62.3-36v33.2c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-37.5c0-.2,0-.3,0-.5h0ZM69.5,198.6L7.6,162.4s0,0,.1,0l29.5-17.1,62.1,36.1-29.9,17.2h0ZM104.4,178.5l-62.1-36.1,24.7-14.3c.8-.5,1.8-.7,2.8-.7s1.9.2,2.8.7l59.3,34.5-27.4,15.8h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso25NubePos);
export default __webpack_public_path__ + "static/media/Recurso 25Nube-pos.b3ab180053f8ef52d2d9cfcfa1b40ed0.svg";
export { ForwardRef as ReactComponent };